import {
  answerCase,
  autoAnswerCase,
  getContactEventLoggingAPIHandler,
  getMiloDeeplink,
  getTransferEndpoints,
  updateContactReleaseToAIL,
} from "../api/session-api";
import {
  STATE_CASE,
  API_ACTIVE_CASE_UPDATE,
  API_MILO_CASE_CHANNEL_TRANSACTION,
  INTERNAL_CASE_RELEASE,
  TELEMETRY_ERROR,
  TELEMETRY_INFO,
  API_CASE_AUTO_ANSWER,
} from "../constants/events";
import // IndividualCase,
//resetNormalCase,
// updateNormalCase,
// setActiveCaseUpdate,
"../reducers/case";
import {
  individualCaseReset,
  setActiveCaseUpdate,
  setCaseState,
} from "../actions/case";
import { setCurrentSessionTab } from "../actions/session";
import storeRTK from "../store/storeRTK";
import Emitter from "../emitter";
import { IndividualCase } from "../types/case.type";
import { IndividualTask } from "../amazon-connect/models/task";
import { notificationManager } from "../utils/NotificationManager";
import { SessionEvent } from "../types/call.type";
import { LIVE_CASE } from "../constants/constants";
import { setSelectedTab } from "../actions/common";
import { casePlayer } from "../amazon-connect/handlers/task";

function caseHandler(event: any) {
  if (event.body?.self?.state) {
    if (event.body?.self?.state == "RELEASED") {
      const state = storeRTK.getState();
      const ifCasePresent = state.cases.cases.findIndex(
        (indCase: any) => indCase.id === event.body?.id
      );

      if (ifCasePresent > -1) {
        Emitter.emit(INTERNAL_CASE_RELEASE, event);
      }
      
      // check if there is another ringing case except the current one, if yes dont pause the ringer
      const ifRingingCasePresent = state.cases.cases.filter(
        (indCase: any) =>
          indCase.self?.state === "RINGING" && indCase.id !== event.body?.id
      );
      //to pause the ring only once, as the release event can come multiple
      // times and it can pause ringing of other cases.
      // if case is present and there is no ringing case
      if (ifCasePresent > -1 && ifRingingCasePresent.length === 0) {
        casePlayer.pause();
        notificationManager.stopFaviconBlinking();
      }
      const wasActive = event.body.id === state.cases.activeCaseID;
      let getActiveCaseIndex = null;
      if (wasActive) {
        getActiveCaseIndex = state.cases.cases.findIndex(
          (indCase: any) => indCase.id === state.cases.activeCaseID
        );
      }

      // Create a new case object instead of mutating the existing one
      const updatedCase = {
        ...event.body,
        self: { ...event.body.self },
        customer: event.body.customer ? { ...event.body.customer } : undefined
      };

      storeRTK.dispatch(individualCaseReset(updatedCase));

      if (wasActive) {
        const newState = storeRTK.getState();
        const len = newState.cases.cases.length;
        if (len === 0) {
          // const body = { caseID: "" }; //changed here
          storeRTK.dispatch(setActiveCaseUpdate(""));
        } else if (getActiveCaseIndex != null && getActiveCaseIndex <= len) {
          const currentActiveCaseID = newState.cases.activeCaseID;
          const getCaseIndex = newState.cases.cases.findIndex(
            (indCase: any) => indCase.id === currentActiveCaseID
          );
          const newActiveCaseIndex =
            getActiveCaseIndex > 0 && getActiveCaseIndex <= len
              ? getActiveCaseIndex - 1
              : 0;
          if (getCaseIndex === -1) {
            storeRTK.dispatch(
              setActiveCaseUpdate({
                caseID: newState.cases.cases[newActiveCaseIndex].id,
              })
            );
          }
        }
      }
      updateContactReleaseToAIL("case", event.body?.id as string);
    } else if (event.body?.self?.state == "TERMINATED") {
      //Do nothing
    } else if (event.body) {
      let state = storeRTK.getState();
      const existingCaseIndex = state.cases.cases.findIndex(
        (indCase: any) => indCase.id === event.body?.id
      );

      // let caseSelfState = null;
      // if (existingCaseIndex !== -1) {
      //   caseSelfState = state.cases?.cases[existingCaseIndex]?.self?.state;
      // }
      let newCases = [...state.cases.cases];
      newCases[existingCaseIndex] = {
        ...newCases[existingCaseIndex],
        ...event.body,
      };
      storeRTK.dispatch(setCaseState(event.body));
      state = storeRTK.getState();

      // Create a new case object instead of mutating the existing one
      const updatedCase = {
        ...event.body,
        self: { ...event.body.self },
        customer: event.body.customer ? { ...event.body.customer } : undefined
      };

      storeRTK.dispatch(setCaseState(updatedCase));

      const newState = storeRTK.getState();
      if (
        newState.cases.cases.length === 1 &&
        newState.cases.cases[0].id !== newState.cases.activeCaseID
      ) {
        storeRTK.dispatch(setActiveCaseUpdate({ caseID: newState.cases.cases[0].id }));
      }

      if (existingCaseIndex == -1) {
        if (event.body?.self?.state === "RINGING") {
          storeRTK.dispatch(setSelectedTab(LIVE_CASE));
          storeRTK.dispatch(setCurrentSessionTab({id: 'case'}));
          getContactEventLoggingAPIHandler(event?.body?.id ?? "", "RINGING");
          
          notificationManager.playRingtone(casePlayer);
          notificationManager.startFaviconBlinking();
          try {
            if(event.body?.id) {
                checkForAutoAnswer(event.body.id); 
            }
          } catch (e:any) {
              console.log('Error in checkForAutoAnswer ' + e.message);
          }
          notificationManager.show("You have an incoming case", {
            body: "Click or open AIC Web to answer it",
            icon: "case.png",
            onclick: () => {
              caseAnswer(event.body?.id, event.body?.self.id);
            },
          });
        }
      }
      // Universal check: pause ringtone if no cases are ringing
      const ringingCases = newState.cases.cases.filter(
        (indCase: any) => indCase.self?.state === "RINGING"
      );
      
      if (ringingCases.length === 0) {
        casePlayer.pause();
        notificationManager.stopFaviconBlinking();
      }
    }
  }
}

function checkForAutoAnswer(caseId: string) {
  const state = storeRTK.getState();
  if (
    state.agent?.aicConfig?.auto_answer_case_enabled === "true" &&
    state.agent?.aicConfig?.auto_answer_case_timeout &&
    state.agent?.aicConfig?.auto_answer_case_timeout * 1 >= 0
  ) {
    setTimeout(() => {
      const cs = storeRTK.getState();
      const agentEmail = cs.agent?.email;
      const cc = cs.cases?.cases?.find((c: IndividualCase) => c.id === caseId);
      if (cc && cc.id && cc.self?.state === "RINGING") {
        caseAnswer(caseId);
        autoAnswerCase(caseId);
        Emitter.emit(TELEMETRY_ERROR, {
          type: "notif",
          chan: TELEMETRY_INFO,
          body: {
            type: API_CASE_AUTO_ANSWER,
            chan: API_CASE_AUTO_ANSWER,
            case_id: caseId,
            message:
              "Auto answering case after ring timeout with contactId = " +
              caseId +
              " by agent = " +
              agentEmail,
          },
        });
      } else {
        Emitter.emit(TELEMETRY_ERROR, {
          type: "notif",
          chan: TELEMETRY_INFO,
          body: {
            type: API_CASE_AUTO_ANSWER,
            chan: API_CASE_AUTO_ANSWER,
            case_id: caseId,
            message:
              "No Auto answer!!, Case already answered or rejected, contactId = " +
              caseId +
              +" by agent = " +
              agentEmail,
          },
        });
      }
    }, state.agent.aicConfig.auto_answer_case_timeout * 1000);
  }
}

export function caseAnswer(activeCaseId: string, participantId?: string) {
  if(!activeCaseId) {
    console.log("Error: activeCaseId is not present");
    return;
  }
  storeRTK.dispatch(setCurrentSessionTab({ id: "case" }));
  storeRTK.dispatch(
    setActiveCaseUpdate({
      caseID: activeCaseId,
    })
  );

  try {
    answerCase({
      participantId: participantId || '', // Assuming a default value of ''
      conversationId: activeCaseId || "", // Provide a valid conversationId here
    });
  } catch (e: any) {
    console.log(
      "Error in answering the case through notification: " + e.message
    );
  }
}

export function updateActiveCaseTab(event: any) {
  if (event) {
    let existingCases = storeRTK.getState().cases.cases;
    let caseExists = existingCases.findIndex(
      (c: IndividualTask) => c.id === event
    );
    if (caseExists > -1) {
      storeRTK.dispatch(setActiveCaseUpdate(event));
    } else {
      // let state = storeRTK.getState();
      // sendMessage({
      //   type: "notif",
      //   chan: SESSION_STATE,
      //   body: state,
      //   success: true,
      // });
    }
  }
}

async function miloHandlerEvent(ev: SessionEvent<any>) {
  const miloEvent = {
    body: {
      contactId: ev.body.contactId,
    },
  };
  notificationManager.triggerMilo(miloEvent, "case");
}

// Milo redirect to CRM
export async function miloHandlerForCase(ev: any) {
  // contactEstablished(ev.body?.contactId);
  const miloDeeplink = await getMiloDeeplink(
    "case",
    ev.body?.contactId
  );
  if (miloDeeplink) {
      // put half sec timeout because milo can come immediately and bg state may not be updated till then.
      setTimeout(()=> {
        window.open(miloDeeplink, "_blank");
      }, 100);
  }
}

export default function registerCaseHandlers() {
  Emitter.on(STATE_CASE, caseHandler);
  Emitter.on(API_ACTIVE_CASE_UPDATE, updateActiveCaseTab);
  Emitter.on(API_MILO_CASE_CHANNEL_TRANSACTION, miloHandlerEvent);
}
